<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Laporan Penyata Penyesuaian">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_bayar_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <!-- <w-input v-model="cari.no_resit" label="No. Resit " /> -->
                        <z-lookup
                            label="Cara Bayaran"
                            :url="service_ibayaq + 'cara_terima'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_cara_terima_id"
                        />
                        <z-lookup
                            label="Jabatan"
                            :url="service_ibayaq + 'jabatan'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_bayar_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Jenis Pembayaran"
                            :url="service_ibayaq + 'sumber'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_sumber_id"
                        />
                        <z-lookup
                            label="Status Penyesuaian"
                            :url="service_ibayaq + 'penyesuaian_status'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.penyesuaian_status"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <z-table
                ref="tbluser"
                title=""
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
            </z-table>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" id="cetak" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_ibayaq + "laporan/penyata_penyesuaian",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Penyata Penyesuaian", route: "/penyesuaian/laporan-recon"},
                { label: "Laporan", route: "/penyesuaian/laporan-recon"},
                {
                    label: "Laporan Penyata Penyesuaian",
                    route: "/penyesuaian/laporan-recon",
                },
            ],
            cari: { tarikh_bayar_dari: "", tarikh_bayar_hingga: "", no_resit: "", lkp_cara_terima_id: "", lkp_sumber_id: "", lkp_jabatan_id: "", penyesuaian_status: ""},
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("penyesuaian.laporanRecon") + 
                    "?tarikh_bayar_dari=" + this.cari.tarikh_bayar_dari +
                    "&tarikh_bayar_hingga=" + this.cari.tarikh_bayar_hingga+
                    "&no_resit=" + this.cari.no_resit+
                    "&lkp_cara_terima_id=" + this.cari.lkp_cara_terima_id+
                    "&lkp_sumber_id=" + this.cari.lkp_sumber_id+
                    "&lkp_jabatan_id=" + this.cari.lkp_jabatan_id+
                    "&penyesuaian_status=" + this.cari.penyesuaian_status,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = { tarikh_bayar_dari: "", tarikh_bayar_hingga: "", no_resit: "", lkp_cara_terima_id: "", lkp_sumber_id: "", lkp_jabatan_id: "", penyesuaian_status: ""};
            this.search();
        },

        cetak() {
            document.getElementById("cetak").disabled = true;
            window.location.href = this.service_ibayaq+'laporan/penyata_penyesuaian/cetak?user_id='+this.auth.user.id+
            "&tarikh_bayar_dari=" + this.cari.tarikh_bayar_dari +
            "&tarikh_bayar_hingga=" + this.cari.tarikh_bayar_hingga+
            "&no_resit=" + this.cari.no_resit+
            "&lkp_cara_terima_id=" + this.cari.lkp_cara_terima_id+
            "&lkp_sumber_id=" + this.cari.lkp_sumber_id+
            "&lkp_jabatan_id=" + this.cari.lkp_jabatan_id+
            "&penyesuaian_status=" + this.cari.penyesuaian_status;
        },
    },
    watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_bayar_dari == "undefined") {
            this.cari.tarikh_bayar_dari = "";
        }
        if (this.cari.tarikh_bayar_hingga == "undefined") {
            this.cari.tarikh_bayar_hingga = "";
        }
        if (this.cari.no_resit == "undefined") {
            this.cari.no_resit = "";
        }
        if (this.cari.lkp_cara_terima_id == "undefined") {
            this.cari.lkp_cara_terima_id = "";
        }
        if (this.cari.lkp_sumber_id == "undefined") {
            this.cari.lkp_sumber_id = "";
        }
        if (this.cari.lkp_jabatan_id == "undefined") {
            this.cari.lkp_jabatan_id = "";
        }
        if (this.cari.penyesuaian_status == "undefined") {
            this.cari.penyesuaian_status = "";
        }
        // console.log(this.auth.user.id);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
